// Import necessary libraries
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Optional: for global styles
import App from './App'; // Import the main App component
import ErrorPopup from './components/ErrorPopup';

import { LocalizationHelper, Providers } from "@microsoft/mgt-element";
import { Msal2Provider } from "@microsoft/mgt-msal2-provider";

// Providers.globalProvider = new Msal2Provider({
//     clientId: '84409242-385c-46f7-b19c-f8db15ff43cd',
//      postLogoutRedirectUri: 'http://localhost:3000/',
//      scopes:['user.read','people.read']
//   });

Providers.globalProvider = new Msal2Provider({
  clientId: process.env.REACT_APP_CLIENT_ID,
  authority: process.env.REACT_APP_AUTHORITY, 
// Remplacez <tenant-id> par l'ID de votre tenant ou le domaine
  postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI,
  scopes: [
    "user.read",
    // "api://8e518cae-4fa5-4f18-9796-352e307c78ce/access_as_user"
    `api://${process.env.REACT_APP_BACKEND_CLIENT_ID}/access_as_user`
  ]
});

LocalizationHelper.strings = {
  _components: {
    login: {
      signInLinkSubtitle: "Se connecter",
      signOutLinkSubtitle: "Se déconnecter",
      signInWithADifferentAccount: "Se connecter avec un autre compte",
    },
  },
};


// Create the root and render the App component into the DOM
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorPopup />
    <App />
  </React.StrictMode>
);
